<template>
    <div class="ClientForm">
        <DashboardEditSection title="Information">
            <FormInput
                v-model="$v.name.$model"
                lazy
                label="Client Name"
                :errors="$v.name.$error ? [
                    !$v.name.required && 'Client name is required',
                    !$v.name.minLength && 'Must be at least 3 characters long',
                ] : null"
                required
            />
            <Row>
                <Column :md="6">
                    <FormInput v-model="firstName" label="First Name"/>
                </Column>
                <Column :md="6">
                    <FormInput v-model="lastName" label="Last Name"/>
                </Column>
            </Row>
            <FormInput
                v-model="$v.email.$model"
                lazy
                label="Email"
                :errors="$v.email.$error ? [
                    !$v.email.minLength && 'Must be at least 3 characters long',
                ] : null"
            />
            <FormInput v-model="phone" label="Phone"/>
        </DashboardEditSection>

        <DashboardEditSection title="Address">
            <AddressForm
                :address.sync="address"
                :city.sync="city"
                :state.sync="state"
                :zip.sync="zip"
            />
        </DashboardEditSection>
    </div>
</template>

<script>
import DashboardEditSection from '@/components/DashboardEditSection';
import AddressForm from '@/components/form/AddressForm';
import { required, minLength } from 'vuelidate/lib/validators';

export default {
    name: 'ClientForm',

    components: {
        DashboardEditSection,
        AddressForm,
    },

    syncProps: [
        'name',
        'firstName',
        'lastName',
        'email',
        'phone',
        'address',
        'city',
        'state',
        'zip',
    ],

    validations: {
        name: {
            required,
            minLength: minLength(3),
        },
        email: {
            minLength: minLength(3),
        },
    },

    methods: {
        validate() {
            this.$v.$touch();
            return !this.$v.$invalid;
        },
    },
}
</script>
